import React, { Component } from 'react';
import LazyHydrate from 'react-lazy-hydration';
import PropTypes from 'prop-types';
import { JsonLd } from 'react-schemaorg';
import { isMobileSafari } from 'react-device-detect';
import Fullscreen from 'react-full-screen';
import get from 'lodash/get';
import replace from 'lodash/replace';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import absoluteUrl from 'helpers/absoluteUrl';
import preload from 'api/data-preload';
import seoPreload, { seoDecorator } from 'api/seo';
import AskQuestion from 'subsys/ask-question';
import { marketStatEvents, mstatDecorator } from 'subsys/market-stat';
import sensor from 'components/sensor';
import Row, { Col } from 'components/row';
import Link from 'components/link';
import { SeoText } from 'components/layouts';
import Container from 'components/container';
import Breadcrumbs from 'components/breadcrumbs';
import Icon, { iconTypes } from 'components/icon';
import { OpenGraphImage } from 'components/image';
import { Maps, BaseLayersUser, InfoLayer, FullscreenControl } from 'containers/maps';

import linksDomik from 'src-sites/domik/links';
import { phoneDomik, emailDomik } from 'src-sites/domik/config';

import marker from '../assets/map-marker';
// import config from '../../../config';

import defaultLogoDomik from 'src-sites/domik/assets/logo-domik.jpg';
import imgMain from './assets/contacts.jpeg';

import translates from './contacts-i18n.json';

import 'styles/domik/section-contacts/_page-contacts.scss';

const bemClasses = new Bem('pageContacts');

@preload({
  ...seoPreload({ entity: 'pageContacts' }, [])
})
@seoDecorator({
  advancedVars: {
    bottomText: 'Текст в самом низу'
  }
})
@mstatDecorator(marketStatEvents.historyChange, () => ({ entity: 'Контакты' }))
@sensor
@I18nHoc(translates)
export default class PageContacts extends Component {
  static propTypes = {
    className: PropTypes.string,
    seoData: PropTypes.shape({})
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.onHandleResize = this.onHandleResize.bind(this);
    this.onResize = this.onHandleResize;

    this.state = {
      isFullScreenMode: false
    };
  }

  componentDidMount() {
    this.onHandleResize(this.sensor.getRuntime());
  }

  onHandleResize({ media: { desktop, tablet, phone } = {} }) {
    const { device } = this.state;

    if (desktop && device !== 'desktop') return this.setState({ device: 'desktop' });
    if (tablet && device !== 'tablet') return this.setState({ device: 'tablet' });
    if (phone && device !== 'phone') return this.setState({ device: 'phone' });
  }

  handleScreenClick=()=> {
    this.setState({ isFullScreenMode: !(this.state.isFullScreenMode) });
  }

  render() {
    const { i18n } = this;
    const { isFullScreenMode } = this.state;
    const { className, seoData } = this.props;
    const pathname = get(this, 'props.location.pathname');
    const seoText = get(seoData, 'bottomText');
    const header = get(seoData, 'header') ? seoData.header : i18n('contactsH1');
    const description = get(seoData, 'description') ? seoData.description : i18n('contactsDescription');
    // const urlToFB = config.fbDomik.url;
    // const urlToYT = config.yTDomik.url;
    // const urlToTelegram = config.telegramlink.url;
    const geo = {
      coordinates: [30.5215092216963, 50.4956635557467],
      parameters: { distance: 10000 },
      type: 'Point'
    };
    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksDomik.sectionDomik,
        builderProps: { title: i18n('breadcrumbsMain') }
      }, {
        name: header,
        builder: linksDomik.sectionContacts
      }
    ];

    return (
      <div {...bemClasses({ extra: className })}>
        <LazyHydrate ssrOnly>
          <OpenGraphImage />
        </LazyHydrate>
        <div {...bemClasses('imgMainContainer')}>
          <div {...bemClasses('imgMain', null, 'image image_imgOrigin')}>
            <img {...bemClasses('img', null, 'image__imgImage')} src={imgMain} alt={i18n('contactsH1')} loading="lazy" decoding="async" />
          </div>
        </div>
        <Container body>
          <Row {...bemClasses('row', 'main')} allColumn>
            <Col allPr={0}>
              <Row {...bemClasses('row', 'title')}>
                <Col {...bemClasses('col', 'main')} allPr={0}>
                  <div {...bemClasses('title')}>
                    <div {...bemClasses('text')}><h1 children={header} /></div>
                  </div>
                </Col>
              </Row>
              <Row {...bemClasses('row', 'bottom')} mtColumn mpColumn>
                <Col {...bemClasses('col', 'description')} allPr={0}>
                  <p
                    {...bemClasses('text', 'description')}
                    children={description}
                  />
                </Col>
                <Col {...bemClasses('col', 'info')} allAuto allPr={0}>
                  <Trans lang="ru">
                    <div {...bemClasses('info')}>
                      <div {...bemClasses('item', 'topic')}>
                        <p {...bemClasses('text', 'label')} children="Название" />
                        <p {...bemClasses('text', 'info')} children="Частное предприятие «РЕКЛАМНОЕ АГЕНТСТВО ДОМИК НЕТ»" />
                      </div>
                      <div {...bemClasses('item', 'foundingDate')}>
                        <p {...bemClasses('text', 'label')} children="Время работы" />
                        <p {...bemClasses('text', 'info')} children="Пн - Пт: с 09:00 до 18:00" />
                        <p {...bemClasses('text', 'info')} children="Сб - Вс: выходной" />
                      </div>
                      <div {...bemClasses('item')}>
                        <p {...bemClasses('text', 'label')} children="Адрес" />
                        <p {...bemClasses('text', 'info')} children="04210, г. Киев, Оболонский р-н, пр-т Героев Сталинграда, 6б, кор. 3, оф.1" />
                      </div>
                    </div>
                  </Trans>
                  <Trans lang="ua">
                    <div {...bemClasses('info')}>
                      <div {...bemClasses('item', 'topic')}>
                        <p {...bemClasses('text', 'label')} children="Назва" />
                        <p {...bemClasses('text', 'info')} children="Приватне підприємство «РЕКЛАМНЕ АГЕНТСТВО ДОМІК НЕТ»" />
                      </div>
                      <div {...bemClasses('item', 'foundingDate')}>
                        <p {...bemClasses('text', 'label')} children="Час роботи" />
                        <p {...bemClasses('text', 'info')} children="Пн - Пт: з 09:00 до 18:00" />
                        <p {...bemClasses('text', 'info')} children="Сб - Нд: вихідний" />
                      </div>
                      <div {...bemClasses('item')}>
                        <p {...bemClasses('text', 'label')} children="Адреса" />
                        <p {...bemClasses('text', 'info')} children="04210, м. Київ, Оболонський р-н, пр-т Героїв Сталінграда, 6б, кор. 3, оф.1" />
                      </div>
                    </div>
                  </Trans>
                </Col>
              </Row>
              <Row {...bemClasses('row', 'map')}>
                <Col {...bemClasses('col', 'map')} allPr={0}>
                  <div {...bemClasses('mapContainer')}>
                    <Fullscreen
                      enabled={isFullScreenMode}
                      onChange={
                        isFullScreen => this.setState({
                          isFullScreenMode: isFullScreen
                        })
                      }
                    >
                      <Maps
                        {...bemClasses('map')}
                        noAutoGeolocate
                        adaptiveScrollZoom={2000}
                        maxZoom={17}
                      >
                        <BaseLayersUser key="bl" />
                        {!isMobileSafari &&
                          <FullscreenControl
                            key="fs"
                            isFullscreen={isFullScreenMode}
                            onScreenIconClick={this.handleScreenClick}
                            position="topleft"
                          />
                        }
                        <InfoLayer
                          key="gc"
                          noAutoFit
                          data={[geo]}
                          maxZoom={18}
                          markerProps={{ icon: marker() }}
                        />
                        <InfoLayer
                          fitMaxZoom={17}
                          minZoom={19}
                          key="il"
                          data={[geo]}
                        />
                      </Maps>
                    </Fullscreen>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row {...bemClasses('row', 'connection')} mtColumn mpColumn>
            <Col allPr={0}>
              <AskQuestion
                {...bemClasses('blockAskQuestion')}
                // ref={ref => this.myRef = ref}
                controller="support/ask-question/ask-us-question"
                entity="ask_question"
                url={pathname}
                otherProps={{
                  notificationMessageSuccess: i18n('askQuestionNotification'),
                  inputPhoneProps: { noLabel: true, noElementBefore: true },
                  additionalMain: true,
                  headerTopic: true,
                  headerTopicText: i18n('askQuestionTopic')
                }}
              />
            </Col>
            <Col mdAuto allPr={0}>
              <Trans lang="ru">
                <div {...bemClasses('connection')}>
                  <div {...bemClasses('text', 'h2')}>
                    <h2 children="Наши подразделения" />
                  </div>
                  <ul {...bemClasses('ul')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Служба поддержки сайта" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Редакция портала" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Отдел рекламы" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Служба поддержки форума" />
                    </li>
                  </ul>
                  <div {...bemClasses('text', 'h2')}>
                    <h2 children="Как с нами связаться" />
                  </div>
                  <div>
                    <p {...bemClasses('text')} children="Связаться с нашими отделами вы можете по телефону, либо отправить свой вопрос при помощи формы обратной связи." />
                  </div>
                  <div>
                    <Link
                      {...bemClasses('link', 'tel')}
                      href={`tel:${replace(phoneDomik, /[\s\(\)]/g, '')}`}
                      external
                    >
                      <span {...bemClasses('linkContent')}>
                        <Icon {...bemClasses('icon', 'tel')} type={iconTypes.phoneCalls} />
                        <span {...bemClasses('text')} children={`${phoneDomik} (многоканальный)`} />
                      </span>
                    </Link>
                  </div>
                </div>
              </Trans>
              <Trans lang="ua">
                <div {...bemClasses('connection')}>
                  <div {...bemClasses('text', 'h2')}>
                    <h2 children="Наші підрозділи" />
                  </div>
                  <ul {...bemClasses('ul')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Служба підтримки сайту" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Редакція порталу" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Відділ реклами" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Служба підтримки форуму" />
                    </li>
                  </ul>
                  <div {...bemClasses('text', 'h2')}>
                    <h2 children="Як з нами зв'язатися" />
                  </div>
                  <div>
                    <p {...bemClasses('text')} children="Зв'язатися з нашими відділами ви можете за телефоном, або відправити своє запитання за допомогою форми зворотного зв'язку." />
                  </div>
                  <div>
                    <Link
                      {...bemClasses('link', 'tel')}
                      href={`tel:${replace(phoneDomik, /[\s\(\)]/g, '')}`}
                      external
                    >
                      <span {...bemClasses('linkContent')}>
                        <Icon {...bemClasses('icon', 'tel')} type={iconTypes.phoneCalls} />
                        <span {...bemClasses('text')} children={`${phoneDomik} (багатоканальний)`} />
                      </span>
                    </Link>
                  </div>
                </div>
              </Trans>
            </Col>
          </Row>
        </Container>
        <Container body>
          <Breadcrumbs {...bemClasses('breadcrumbs')} data={dataBreadcrumbs} />
          <SeoText data={seoText} />
        </Container>
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: header,
            telephone: phoneDomik,
            alternateName: 'domik.ua',
            description: description,
            email: emailDomik,
            logo: absoluteUrl(defaultLogoDomik),
            image: absoluteUrl(defaultLogoDomik),
            url: absoluteUrl(''),
            // sameAs: [urlToFB, urlToYT, urlToTelegram],
            // geo: geo && geo.type === 'Point' ? {
            //   '@type': 'GeoCoordinates',
            //   latitude: geo.coordinates[1],
            //   longitude: geo.coordinates[0]
            // } : null,
            contactPoint: {
              telephone: phoneDomik,
              email: emailDomik,
              contactType: 'customer service',
              areaServed: 'UA',
              hoursAvailable: [
                {
                  closes: '18:00:00',
                  dayOfWeek: 'https://schema.org/Monday',
                  opens: '09:00:00'
                }, {
                  closes: '18:00:00',
                  dayOfWeek: 'https://schema.org/Tuesday',
                  opens: '09:00:00'
                }, {
                  closes: '18:00:00',
                  dayOfWeek: 'https://schema.org/Wednesday',
                  opens: '09:00:00'
                }, {
                  closes: '18:00:00',
                  dayOfWeek: 'https://schema.org/Thursday',
                  opens: '09:00:00'
                }, {
                  closes: '18:00:00',
                  dayOfWeek: 'https://schema.org/Friday',
                  opens: '09:00:00'
                }
              ]
            },
            address: {
              '@type': 'PostalAddress',
              postalCode: '04210',
              addressCountry: i18n('addressCountry'),
              addressRegion: i18n('addressRegion'),
              addressLocality: i18n('addressLocality'),
              streetAddress: i18n('streetAddress')
            }
          }}
        />
      </div>
    );
  }
}
